import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import LayoutMain_Orion from "../LayoutMain_Orion/LayoutMain_Orion";
import { decodeToken } from "react-jwt";
import WaterMark from "../../Dashboard/DashboardMain/WaterMark";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";
import "./VehicleInsightOrion.css";
import style from "../OrionGlobal.module.css"
import { GiArtificialIntelligence } from "react-icons/gi";

export default function VehicleInsights_Orion() {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [isDriveOrionEnable, setIsDriveOrionEnable] = useState(false);
  // const [isRcaBusEnable, setIsRcaBusEnable] = useState(false);
  const [isFaultBusEnable, setIsFaultBusEnable] = useState(false);
  const [isChargingEnable, setIsChargingEnable] = useState(false);
  // const [usernameTempHideShow, setUsernameTempHideShow] = useState(false);
  const [isCriticalVehicles, setCriticalVehicles] = useState(false);
  const [isCriticalVehiclesFleet, setCriticalVehiclesFleet] = useState(false);
  // const [isTrendEnable, setIsTrendEnable] = useState(false);
  const [isEnergyAnalysis, setIsEnergyAnalysis] = useState(false);
  // const [isEnergyBillReconcilliationFleet, setIsEnergyBillReconcilliationFleet] = useState(false);
  // const [ispdfDownload, setIsPdfDownload] = useState(false);
  // const [isChatBot, setIsChatBot] = useState(false);
  // const [isBatteryDigitalTwin, setIsBatteryDigitalTwin] = useState(false);
  // const [isLLM, setLLM] = useState(false);

  const loggedInUser = useSelector(selectLoggedInUser);

  const log_data = (data) => {
    //  console.log(data);
  };
  useEffect(() => {
    fetchData(
      { url: API_URL_MAIN + "auth/logging", body: { page_name: "vehicleinsights_orion", }, }, log_data);
  }, []);

  useEffect(() => {
    const tokenNew = JSON.parse(sessionStorage.user);
    let decodedToken = decodeToken(tokenNew.token);
    let usernameNew = decodedToken.access_type;
   

    usernameNew = usernameNew.trim();
      var split_str = usernameNew ? usernameNew.split(",") : "";
  
    

    if (split_str.indexOf("1") !== -1) {
      setIsDriveOrionEnable(true);
    }
    // if (split_str.indexOf("3") !== -1) {
    //   setIsRcaBusEnable(true);
    // }
    if (split_str.indexOf("4") !== -1) {
      setIsFaultBusEnable(true);
    }
    if (split_str.indexOf("2") !== -1) {
      setIsChargingEnable(true);
    }
    // if (split_str.indexOf("7") !== -1) {
    //   setIsTrendEnable(true);
    // }
    // if (split_str.indexOf("9") !== -1) {
    //   setUsernameTempHideShow(true);
    // }
    if (split_str.indexOf("5") !== -1) {
      setCriticalVehicles(true);
    }
    if (split_str.indexOf("6") !== -1) {
      setCriticalVehiclesFleet(true);
    }
    if (split_str.indexOf("3") !== -1) {
      setIsEnergyAnalysis(true);
    }
    // if (split_str.indexOf("13") !== -1) {
    //   setIsPdfDownload(true);
    // }
    // if (split_str.indexOf("16") !== -1) {
    //   setIsEnergyBillReconcilliationFleet(true);
    // }
    // if (split_str.indexOf("17") !== -1) {
    //   setIsBatteryDigitalTwin(true);
    // }
    // if (split_str.indexOf("18") !== -1) {
    //   setLLM(true);
    // }
    // if (split_str.indexOf("15") !== -1) {
    //   setIsChatBot(true);
    // }
  }, [
    isDriveOrionEnable,
    // isRcaBusEnable,
    isFaultBusEnable,
    isChargingEnable,
    // usernameTempHideShow,
    isCriticalVehicles,
    // isTrendEnable,
    isEnergyAnalysis,
    // isEnergyBillReconcilliationFleet,
    // ispdfDownload,
    // isBatteryDigitalTwin,
    // isChatBot,
    isCriticalVehiclesFleet,
  ]);

  return (
    <LayoutMain_Orion>
      <div className="row">
        <WaterMark />
        {isDriveOrionEnable && (
          <div className="col-md-3">
            <Link to="/dashboard_orion/driveanalysis_orion">
              {/* <div className="dashboard_card_orion"> */}
              <div className={`${style.dashboard_card_orion}`}>
                <img src="../../../assets/img_orion/drive_analysis_bus.png" alt="" />
                <span>Drive Analysis</span>
              </div>
            </Link>
          </div>
        )}
    
         {isFaultBusEnable && (
                  <div className="col-md-3">
                    <Link to="/dashboard_orion/faultanalysis_orion">
                      {/* <div className="dashboard_card"> */}
                          <div className={`${style.dashboard_card_orion}`}>
                        <img
                          src="../../../assets/img_Bus/CESL_Charging/charging_bus_main_card.png"
                          alt=""
                        />
                        <span>Fault Analysis</span>
                      </div>
                    </Link>
                  </div>
                )}
                  {isChargingEnable && (
                  <div className="col-md-3">
                    <Link to="/dashboard_orion/charginganalysis_orion">
                      {/* <div className="dashboard_card"> */}
                          <div className={`${style.dashboard_card_orion}`}>
                        <img
                          src="../../../assets/img_Bus/CESL_Charging/charging_bus_main_card.png"
                          alt=""
                        />
                        <span>Charging Analysis</span>
                      </div>
                    </Link>
                  </div>
                )}
                

                 {isEnergyAnalysis && (
                  <div className="col-md-3">
                    <Link to="/dashboard_orion/energyanalysis_orion">
                          <div className={`${style.dashboard_card_orion}`}>
                        <img
                          src="../../../assets/img_Bus/CESL_Charging/charging_bus_main_card.png"
                          alt=""
                        />
                        <span>Energy Analysis</span>
                      </div>
                    </Link>
                  </div>
                )}

                
                {/* {  loggedInUser.flagForHideShow === "ERC" && isCriticalVehicles &&  (
                  <div className="col-md-3">
                    <Link to="/dashboard_orion/critical_vehicles_orion">
                          <div className={`${style.dashboard_card_orion}`}>
                        <img
                          src="../../../assets/img_Bus/CESL_Charging/charging_bus_main_card.png"
                          alt=""
                        />
                        <span>Critical Vehicles</span>
                      </div>
                    </Link>
                  </div>
                )
                  
                } */}
                 {
                          // loggedInUser.flagForHideShow === "ERC" &&
                          loggedInUser.flagForHideShow === "ERC" && isCriticalVehicles && (
                            <div className="col-md-3">
                              {/* <img src="../../../assets/work_in_progress_blue_final.png" style={{ width: "50px", height: "50px", position: "absolute", right: "25px", top: "30px" }}></img> */}
                              <Link to="/dashboard_orion/criticalvehicles_orion">
                               <div className={`${style.dashboard_card_orion}`}>
                                  <img
                                    src="../../../assets/img_Bus/Critical_Vehicles.png"
                                    alt=""
                                  />
                                  <span>Critical Vehicles</span>
                                </div>
                              </Link>
                            </div>
                          )
                        }
                        {
                          // loggedInUser.flagForHideShow === "ERC" &&
                          loggedInUser.flagForHideShow === "FLEETEV" &&
                          isCriticalVehiclesFleet && (
                            <div className="col-md-3">
                              {/* <img src="../../../assets/work_in_progress_blue_final.png" style={{ width: "50px", height: "50px", position: "absolute", right: "25px", top: "30px" }}></img> */}
                              <Link to="/dashboard_orion/criticalvehicles_orion_ascent">
                                <div className="dashboard_card">
                                  <img
                                    src="../../../assets/img_Bus/Critical_Vehicles.png"
                                    alt=""
                                  />
                                  <span>Critical Vehicles</span>
                                </div>
                              </Link>
                            </div>
                          )
                        }
              
      </div>
    </LayoutMain_Orion>
  );
}
